import _merge from 'lodash/merge'
import { createTheme, Theme, ThemeOptions } from '@mui/material/styles'

import { Brand } from './types'

const getOverrides = (): ThemeOptions => ({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: 'inherit',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 'inherit',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          fontSize: 'inherit',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
  },
})
const getOptions = (brand?: Brand): ThemeOptions => ({
  typography: {
    fontFamily: '"Roboto" , ans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontSize: 11,
    htmlFontSize: 14,
  },
  palette: {
    primary: {
      main: brand?.themeColors?.main ? `#${brand?.themeColors.main}` : '#ff982b',
      contrastText: '#fff',
    },
    secondary: {
      main: '#babababa',
    },
    background: {
      default: '#f4f4f7',
    },
    text: {
      primary: '#252525',
      secondary: '#777777',
    },
  },
  shape: {
    borderRadius: 3,
  },
})
// A custom theme for this app
const theme = createTheme(_merge({}, getOptions(), getOverrides()))

export const customBrandTheme = (brand?: Brand): Theme => createTheme(_merge({}, getOptions(brand), getOverrides()))

export default theme
